import { addProp } from "@pnp/odata";
import { _User } from "../users/types.js";
import { Contacts, ContactFolders } from "./types.js";
addProp(_User, "contacts", Contacts);
addProp(_User, "contactFolders", ContactFolders);
//# sourceMappingURL=users.js.map